import { render, staticRenderFns } from "./vehicleInsurance.vue?vue&type=template&id=6f28253a"
import script from "./vehicleInsurance.vue?vue&type=script&lang=js"
export * from "./vehicleInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports